import { ToolboxTalkSlideType } from "../models/ToolboxTalkSlides";
import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";



export async function getToolboxTalkSlide(id: number) {
  const response = await apiGet("core", `toolbox-talk-page/${id}`);
  return response?.content;
}

export async function addToolboxTalkSlide(newDetails: ToolboxTalkSlideType) {
  const response = await apiPost("core", `toolbox-talk-page`, newDetails);
  return response?.content;
}

export async function updateToolboxTalkSlide(
  id: string,
  newDetails: ToolboxTalkSlideType,
) {
  const response = await apiPut("core", `toolbox-talk-page/${id}`, newDetails);

  return response?.content;
}

export async function removeToolboxTalkSlide(id: any) {
  return await apiDelete("core", `toolbox-talk-page/${id}`);
}
